import { useEffect, useLayoutEffect, useState } from "react"
import useWindowEvent from "../../../helpers/use-window-event.hook"

const useContentTop = (): number => {
  const [top, setTop] = useState(0)

  const detectTopLocation = () => {
    const element = document.querySelector("header")

    if (element) {
      const rect = element.getBoundingClientRect()
      setTop(rect.bottom)
    }
  }

  useEffect(() => {
    // This timeout is needed to get a proper init value (after top bar displaying)
    const timeout = setTimeout(detectTopLocation, 0)
    return () => clearTimeout(timeout)
  })

  useLayoutEffect(() => detectTopLocation())

  useWindowEvent("resize", () => detectTopLocation())

  return top
}

export default useContentTop
